import { render } from "./CustomerSearchButton.vue?vue&type=template&id=1ce359c8"
import script from "./CustomerSearchButton.vue?vue&type=script&lang=js"
export * from "./CustomerSearchButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__